module.exports = __webpack_public_path__ + "static/media/facebook-dark.27bc6d83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/facebook-dark.svg
// module id = 432
// module chunks = 0